import React from 'react'

// Renders a live price string (e.g. "£69"), or a subtle skeleton block while
// /api/v2/services is still loading (useLivePrice returns null until then).
// There are no hardcoded fallback prices - the DB is the single source of
// truth, so a skeleton (not a stale number) bridges the brief initial fetch.
export const PriceText = ({ value }) => {
  if (value) return value
  return (
    <span
      aria-hidden="true"
      style={{
        display: 'inline-block',
        width: '2.2em',
        height: '0.7em',
        borderRadius: 4,
        background: 'currentColor',
        opacity: 0.18,
        verticalAlign: 'middle'
      }}
    />
  )
}
